<template>
  <Disclosure as="nav" class="hdr-nav" v-slot="{ open }">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex">
          <div class="flex-shrink-0 flex items-center">
            <img class="h-8 w-auto hdr-logo hdr-logo--dark" src="@/assets/CruzControl_Logo_Small_Icon.svg" alt="CruzControl" />
            <img class="h-8 w-auto hdr-logo hdr-logo--light" src="@/assets/CruzControl_Logo_Small_Icon_Light.svg" alt="CruzControl" />
          </div>
        </div>
        <div class="hidden sm:ml-6 sm:flex sm:items-center">
          <button type="button" class="hidden p-1 rounded-full focus:outline-none">
            <span class="sr-only">View notifications</span>
            <BellIcon class="h-6 w-6" aria-hidden="true" />
          </button>

          <!-- Theme toggle -->
          <button type="button" @click="toggleTheme" class="hdr-theme-btn" :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'">
            <SunIcon v-if="!isDark" class="h-4 w-4" aria-hidden="true" />
            <MoonIcon v-else class="h-4 w-4" aria-hidden="true" />
          </button>

          <!-- Profile dropdown -->
          <Menu as="div" class="ml-3 relative inline-block">
            <div>
              <MenuButton class="hdr-avatar-btn">
                <span class="sr-only">Open user menu</span>
                <Avatar :username="getName" :inline="true" :size="34"/>
                <span class="hidden sm:block text-sm font-medium hdr-user-name">{{ getName }}</span>
                <ChevronDownIcon class="hidden sm:block h-4 w-4 hdr-chevron" />
              </MenuButton>
            </div>
            <transition enter-active-class="transition ease-out duration-200" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
              <MenuItems class="hdr-dropdown">
                <MenuItem v-for="item in userNavigation" :key="item.name" v-slot="{ active }">
                  <a :href="item.href" :class="['hdr-dropdown__item', active ? 'hdr-dropdown__item--active' : '']">{{ item.name }}</a>
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
        </div>
        <div class="-mr-2 flex items-center sm:hidden">
          <!-- Mobile menu button -->
          <DisclosureButton class="hdr-mobile-btn">
            <span class="sr-only">Open main menu</span>
            <MenuIcon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
            <XIcon v-else class="block h-6 w-6" aria-hidden="true" />
          </DisclosureButton>
        </div>
      </div>
    </div>

    <DisclosurePanel class="hdr-panel">
      <div class="pt-2 pb-3 space-y-1">
        <DisclosureButton v-for="item in navigation" :key="item.name" as="a" :href="item.href" :class="['hdr-panel-link', isCurrentRoute ? 'hdr-panel-link--active' : '']" :aria-current="item.current ? 'page' : undefined">{{ item.name }}</DisclosureButton>
      </div>
      <div class="hdr-panel-user">
        <div class="flex items-center px-4 gap-3">
          <!-- <div class="flex-shrink-0">
            <Avatar :username="getName" :size="36"/>
          </div> -->
          <div>
            <div class="hdr-panel-user__name">{{ getName }}</div>
            <div class="hdr-panel-user__email">{{ getUserEmail }}</div>
          </div>
        </div>
        <div class="mt-3 space-y-1">
          <DisclosureButton v-for="item in userNavigation" :key="item.name" as="a" :href="item.href" class="hdr-panel-user-link">{{ item.name }}</DisclosureButton>
          <!-- Mobile theme toggle -->
          <button type="button" @click="toggleTheme" class="hdr-panel-user-link hdr-panel-theme-btn">
            <component :is="isDark ? SunIcon : MoonIcon" class="h-4 w-4 inline-block mr-2" aria-hidden="true" />
            {{ isDark ? 'Light Mode' : 'Dark Mode' }}
          </button>
        </div>
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script>

import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { BellIcon, MenuIcon, XIcon } from '@heroicons/vue/outline'
import { ChevronDownIcon, SunIcon, MoonIcon } from '@heroicons/vue/solid'
import {mapGetters, mapMutations, mapState} from "vuex";


const navigation = [
  { name: 'Dashboard', href: '/dashboard', current: true },
]
const userNavigation = [
  //{ name: 'Your Profile', href: '/profile' },
  { name: 'Logout', href: '/logout' }
]

export default {
  name: "headerComponent",
  components:{
    Disclosure,
    DisclosurePanel,
    DisclosureButton,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    BellIcon,
    MenuIcon,
    XIcon,
    ChevronDownIcon,
    SunIcon,
    MoonIcon
  },
  setup() {
    return { navigation, userNavigation, SunIcon, MoonIcon }
  },
  data() {
    return {
      user: {
        email: "test@test.com",
        name: "test"
      },
    }
  },
  computed: {
    ...mapState(['currentRoute']),
    ...mapGetters(["getFullName", "getEmail", "getCurrentRoute", "getTheme"]),
    getName() {
     return this.getFullName
    },
    getUserEmail() {
      return this.getEmail
    },
    isCurrentRoute() {
      return this.currentRoute === this.$route.path;
    },
    isDark() {
      return this.getTheme === 'dark';
    }
  },
  methods: {
    ...mapMutations(["setTheme"]),
    toggleTheme() {
      this.setTheme(this.isDark ? 'light' : 'dark');
    }
  },
  watch: {
    'currentRoute': function(val, oldVal) {
      // is triggered whenever the store state changes
      console.log('do stuff', val, oldVal);
    }
  }
}
</script>

<style scoped>
.hdr-nav {
  background: var(--cc-nav);
  backdrop-filter: blur(16px) saturate(150%);
  -webkit-backdrop-filter: blur(16px) saturate(150%);
  border-bottom: 1px solid var(--cc-nav-border);
  position: sticky;
  top: 0;
  z-index: 50;
  transition: background 0.3s ease, border-color 0.3s ease;
}

/* Dual logo: hide light by default, show in light mode */
.hdr-logo--light { display: none; }
[data-theme="light"] .hdr-logo--dark  { display: none; }
[data-theme="light"] .hdr-logo--light { display: block; }

/* Theme toggle button */
.hdr-theme-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--cc-toggle-bg);
  border: none;
  border-radius: 6px;
  color: var(--cc-toggle-icon);
  cursor: pointer;
  margin-right: 0.5rem;
  transition: background 0.18s, color 0.18s;
}
.hdr-theme-btn:hover { background: var(--cc-toggle-hover); color: var(--cc-t1); }
.hdr-theme-btn:focus { outline: none; box-shadow: 0 0 0 2px rgb(0, 146, 191); }

.hdr-avatar-btn {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 0.25rem 0.625rem;
  cursor: pointer;
  font-family: 'Barlow', sans-serif;
  transition: background 0.18s;
}
.hdr-avatar-btn:hover { background: var(--cc-toggle-bg); }
.hdr-avatar-btn:focus { outline: none; box-shadow: 0 0 0 2px rgba(0, 146, 191, 0.5); border-radius: 6px; }

.hdr-user-name { color: var(--cc-nav-name); transition: color 0.3s; }
.hdr-chevron { color: var(--cc-nav-chevron); transition: color 0.3s; }

.hdr-dropdown {
  position: absolute;
  right: 0;
  z-index: 10;
  margin-top: 0.5rem;
  width: 13rem;
  background: var(--cc-dropdown);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--cc-dropdown-border);
  border-radius: 4px;
  box-shadow: var(--cc-dropdown-shadow);
  overflow: hidden;
  outline: none;
  transition: background 0.3s, border-color 0.3s;
}

.hdr-dropdown__item {
  display: block;
  padding: 0.625rem 1rem;
  font-size: 0.8125rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cc-dropdown-item);
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
}
.hdr-dropdown__item--active,
.hdr-dropdown__item:hover {
  background: rgb(0, 146, 191);
  color: var(--cc-t1);
}

.hdr-mobile-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--cc-mobile-btn);
  transition: background 0.18s, color 0.18s;
}
.hdr-mobile-btn:hover { background: var(--cc-toggle-bg); color: var(--cc-t1); }
.hdr-mobile-btn:focus { outline: none; }

.hdr-panel {
  border-top: 1px solid var(--cc-panel-sep);
  background: var(--cc-panel);
  transition: background 0.3s, border-color 0.3s;
}

.hdr-panel-link {
  display: block;
  padding: 0.625rem 1rem 0.625rem 0.875rem;
  border-left: 3px solid transparent;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--cc-panel-link);
  text-decoration: none;
  transition: all 0.18s;
}
.hdr-panel-link--active { border-left-color: #0092bf; background: rgba(0, 146, 191, 0.08); color: #00bcf5; }
.hdr-panel-link:hover { background: var(--cc-toggle-bg); color: var(--cc-t1); }

.hdr-panel-user { padding: 1rem 0; border-top: 1px solid var(--cc-panel-sep); }
.hdr-panel-user__name { font-size: 0.9375rem; font-weight: 600; color: var(--cc-panel-uname); }
.hdr-panel-user__email { font-size: 0.8125rem; color: var(--cc-panel-email); }

.hdr-panel-user-link {
  display: block;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: var(--cc-panel-ulink);
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-family: 'Barlow', sans-serif;
}
.hdr-panel-user-link:hover { background: var(--cc-toggle-bg); color: var(--cc-t1); }

.hdr-panel-theme-btn { display: flex; align-items: center; }
</style>